// Horizontal scroll gallery. Desktop: vertical scroll drives the track sideways.
// Mobile (per-section "Mobile layout" setting, data-mobile-mode):
//   - "scroll": same pinned scroll-jack animation as desktop
//   - "swipe":  native/drag horizontal strip; the scroll-jack transform is disabled
// Used by PDP + king & queen.
(function () {
  'use strict';
  var MOBILE = '(max-width: 749px)';

  function initGallery(wrap) {
    if (wrap.__sgInit) return; // guard against double-binding (editor re-inits)
    wrap.__sgInit = true;

    var track = wrap.querySelector('.scroll-gallery__track');
    var strip = wrap.querySelector('.scroll-gallery__sticky');
    if (!track) return;
    var mode = wrap.getAttribute('data-mobile-mode') || 'swipe';

    function isSwipeMobile() {
      return mode === 'swipe' && window.matchMedia(MOBILE).matches;
    }

    // --- Scroll-jack animation (desktop always; mobile only when mode === 'scroll') ---
    function update() {
      if (isSwipeMobile()) { track.style.transform = ''; return; }
      var rect = wrap.getBoundingClientRect();
      var total = wrap.offsetHeight - window.innerHeight;
      var max = track.scrollWidth - window.innerWidth;
      var scrolled = -rect.top;
      var t = total > 0 ? Math.min(1, Math.max(0, scrolled / total)) : 0;
      track.style.transform = 'translateX(-' + (t * max) + 'px)';
    }
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();

    // --- Drag-to-swipe (mouse only; touch keeps native momentum scrolling) ---
    if (strip) {
      var down = false, startX = 0, startLeft = 0;

      strip.addEventListener('mousedown', function (e) {
        if (!isSwipeMobile()) return;
        down = true;
        startX = e.clientX;
        startLeft = strip.scrollLeft;
        strip.classList.add('is-dragging');
        e.preventDefault(); // stop native image ghost-drag hijacking the gesture
      });

      document.addEventListener('mousemove', function (e) {
        if (!down) return;
        strip.scrollLeft = startLeft - (e.clientX - startX);
      });

      document.addEventListener('mouseup', function () {
        if (!down) return;
        down = false;
        strip.classList.remove('is-dragging');
        snapToNearest();
      });

      // Smoothly settle on the item nearest the strip's centre.
      function snapToNearest() {
        var items = strip.querySelectorAll('.scroll-gallery__item');
        var center = strip.scrollLeft + strip.clientWidth / 2;
        var target = null, best = Infinity;
        items.forEach(function (it) {
          var d = Math.abs((it.offsetLeft + it.offsetWidth / 2) - center);
          if (d < best) { best = d; target = it; }
        });
        if (target) {
          strip.scrollTo({
            left: target.offsetLeft + target.offsetWidth / 2 - strip.clientWidth / 2,
            behavior: 'smooth'
          });
        }
      }
    }
  }

  function initAll(root) {
    (root || document).querySelectorAll('[data-scroll-gallery]').forEach(initGallery);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  // Shopify theme editor re-renders a section (into a fresh DOM) on setting change.
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();